import { DATA_COLUMN_PROPS } from './props'
import DataWrap from './component/wrap'
import Cell from './component/cell'

export default {
  name: 'KyeDataStatistic',
  props: DATA_COLUMN_PROPS,
  data () {
    return {
      value: [],
    }
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler (val) {
        this.value = val
      }
    }
  },
  render () {
    const props = this.$props
    const commonProps = {
      // localData
      value: this.value,
      // props
      height: props.height,
      layoutModel: props.layoutModel,
      label: props.label,
      showCheckbox: props.showCheckbox,
      cellWrapClassName: props.cellWrapClassName,
      draggedId: props.draggedId,
      selectMode: props.selectMode, // 单选的模式 none 无 single 单选
      draggable: props.draggable,
      morePopoverAttrs: props.morePopoverAttrs,
      customMoreOption: props.customMoreOption,
      draggedPriorityElevation: props.draggedPriorityElevation
    }
    const dataProps = {
      props: {
        ...commonProps
      },
      class: 'kye-data-statistic',
      ref: 'wrap'
    }
    const [slot] = this.$slots.default || []
    const { cell, option } = slot || {}
    const dataSlots = {
      cell: (cellProps) => {
        return <Cell
          {...{
            props: Object.assign({}, commonProps, cellProps)
          }}
        >
          {{
            cell: this.$slots.cell || this.$scopedSlots.cell || cell
          }}
        </Cell>
      },
      option: (optionProps) => {
        return <Cell
          {...{
            props: Object.assign({}, commonProps, optionProps),
          }}
        >
          {{
            cell: this.$slots.option || this.$scopedSlots.option || option
          }}
        </Cell>
      }
    }
    return <DataWrap {...dataProps}>
      {
        dataSlots
      }
    </DataWrap>
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-data-statistic/index.js